import React from "react";
import { useSelector } from "react-redux";

import Box from "@mui/material/Box";
import ActionBox from "../../ActionBox";
import styles from "../Sidebar.module.css";
import { useNavigate } from "react-router-dom";

const actionName = "file";

const FileActionBox = () => {
  const activeAction = useSelector((state) => state.nav.activeAction);
  const navigate = useNavigate();

  const handleClick = () => {
    console.log("i am clicked!");
    navigate("");
  };

  const handleHover = () => {
    console.log("i am hovered!");
  };

  const handleHoverExit = () => {
    console.log("i was hovered!");
  };

  return (
    <ActionBox
      sx={{
        left: "95%",
        top: "0px",
      }}
      isShown={activeAction === actionName ? true : false}
    >
      <ActionBox sx={{ left: "90%", top: "20px" }}>
        <Box>
          <p>Current File:</p>
          <p>Sample_File</p>
        </Box>

        <Box>
          <p>Recent File:</p>
          <ol className={styles.filesList}>
            <li>Sample_File2</li>
            <li>Sample_File3</li>
            <li>Sample_File4</li>
            <li>Sample_File5</li>
            <li>Sample_File6</li>
          </ol>
        </Box>
      </ActionBox>

      <p onClick={handleClick} className="action-box__text">
        Create new file
      </p>
      <p
        onClick={handleClick}
        onMouseEnter={handleHover}
        onMouseLeave={handleHoverExit}
        className="action-box__text"
      >
        Open existing file
      </p>
      <p onClick={handleClick} className="action-box__text">
        Save file
      </p>
      {/* <p onClick={handleClick} className="action-box__text">
        Duplicate file
      </p> */}
      {/* <p onClick={handleClick} className="action-box__text">
        Import data (.csv)
      </p> */}
      <p onClick={handleClick} className="action-box__text">
        Download data (.csv)
      </p>
      <p onClick={handleClick} className="action-box__text">
        Back to menu
      </p>
    </ActionBox>
  );
};

export default FileActionBox;
